import { Role, ShiftStatus, ShiftOfferStatus } from '@caresend/types';
import { hasStatus } from '@caresend/utils';
import { computed } from 'vue';
import { usePortalStore } from '../../../components/specific/portal/store/portal/index.js';
import { shiftDetailsHeadingValues } from './components/shiftDetails.js';
import { getStore } from '../../../store/helpers/initStore.js';

/**
 * If the shift is canceled, pass undefined instead of the heading values
 * so that the heading will not be rendered and we meet the design requirement
 */
const getJobDetailsHeading = (params) => {
    var _a, _b;
    const store = getStore();
    const portalStore = usePortalStore();
    const { shiftID } = params.route.params;
    if (!shiftID)
        throw new Error('Shift ID is missing when loading shift details');
    /**
     * store.state.shifts.shifts should not be undefined according the type
     * definition in this repo but in dashboard we have a separate type definition
     * where it could be undefined
     *
     * we should unify these but for now I have used the optional operator here
     */
    const shift = portalStore.shifts.get(shiftID);
    /**
     * The shift may not be immediately available when the page loads, so
     * this is not a case where we should throw an error
     */
    if (!shift)
        return computed(() => undefined);
    const { user } = store.state.auth;
    if (!user)
        throw Error('User is missing when loading shift details');
    const isNurse = user.role === Role.NURSE;
    const shiftIsCanceled = hasStatus(shift.status, ShiftStatus.CANCELED);
    const nurseHasRespondedToOffer = ((_b = (_a = shift === null || shift === void 0 ? void 0 : shift.nursesOffered) === null || _a === void 0 ? void 0 : _a[user.id]) === null || _b === void 0 ? void 0 : _b.status) !== ShiftOfferStatus.NO_RESPONSE;
    if (isNurse && shiftIsCanceled && nurseHasRespondedToOffer) {
        return computed(() => undefined);
    }
    return computed(() => shiftDetailsHeadingValues(params).value);
};

export { getJobDetailsHeading };
